import { Notification as WdsNotification } from '@wix/design-system';
import React, { useEffect } from 'react';
export const Notification = _ref => {
  let {
    show,
    message,
    action,
    onCloseClick,
    onShow
  } = _ref;
  useEffect(() => {
    show && (onShow == null ? void 0 : onShow(message));
  }, [show, message, onShow]);
  if (!show) {
    return null;
  }
  return /*#__PURE__*/React.createElement(WdsNotification, {
    show: show,
    theme: "error",
    type: "sticky",
    dataHook: "app-notification",
    onClose: onCloseClick
  }, /*#__PURE__*/React.createElement(WdsNotification.TextLabel, {
    ellipsis: false
  }, message), action && /*#__PURE__*/React.createElement(WdsNotification.ActionButton, {
    onClick: action == null ? void 0 : action.onClick,
    type: action == null ? void 0 : action.type
  }, action == null ? void 0 : action.text), /*#__PURE__*/React.createElement(WdsNotification.CloseButton, {
    onClick: () => {
      onCloseClick == null || onCloseClick();
    }
  }));
};
//# sourceMappingURL=Notification.js.map